import { Separator } from '@heroui/react';
import { useTranslation } from 'react-i18next';

import TextLink, { type Props as TextLinkProps } from '@/components/TextLink';

type Props = {
  readonly linkType?: TextLinkProps['type'];
  // eslint-disable-next-line react/boolean-prop-naming
  readonly inline?: boolean;
  readonly termsOfUseUrl?: string;
  readonly privacyPolicyUrl?: string;
};

const TermsLinks = ({ inline, termsOfUseUrl, privacyPolicyUrl, linkType = 'secondary' }: Props) => {
  const { t } = useTranslation();
  // Inside a sentence a link needs an underline to read as one; standalone footer links don't.
  const linkClassName = inline
    ? 'inline whitespace-nowrap text-foreground underline decoration-current/30 underline-offset-2 hover:decoration-current'
    : 'inline';

  return (
    <>
      {termsOfUseUrl && (
        <TextLink
          className={linkClassName}
          isInline={inline}
          text="description.terms_of_use"
          href={termsOfUseUrl}
          type={linkType}
          target="_blank"
          onClick={(event) => {
            event.stopPropagation();
          }}
        />
      )}
      {termsOfUseUrl && privacyPolicyUrl && inline && ` ${t('description.and')} `}
      {termsOfUseUrl && privacyPolicyUrl && !inline && (
        <Separator orientation="vertical" className="mx-3 inline-block h-3 align-middle" />
      )}
      {privacyPolicyUrl && (
        <TextLink
          className={linkClassName}
          isInline={inline}
          text="description.privacy_policy"
          href={privacyPolicyUrl}
          type={linkType}
          target="_blank"
          onClick={(event) => {
            event.stopPropagation();
          }}
        />
      )}
    </>
  );
};

export default TermsLinks;
